import React, { useCallback, useMemo } from 'react';
import { Button } from '@mui/material';
import { UnfoldLess, UnfoldMore } from '@mui/icons-material';

interface Props {
  collapsed: boolean;
  onToggle: (collapsed: boolean) => void;
}

const CollapseExpandSections: React.FC<Props> = ({ collapsed, onToggle }) => {
  const handleOnClick = useCallback(() => {
    onToggle(!collapsed);
  }, [collapsed, onToggle]);

  const text = collapsed ? 'Expand Sections' : 'Collapse Sections';

  const icon = useMemo(() => {
    return collapsed ? <UnfoldMore fontSize="small" /> : <UnfoldLess fontSize="small" />;
  }, [collapsed]);

  return (
    <Button onClick={handleOnClick} type="button" size="small" startIcon={icon} fullWidth>
      {text}
    </Button>
  );
};

export default CollapseExpandSections;
